import script from "./reportXdjh.vue?vue&type=script&setup=true&lang=js"
export * from "./reportXdjh.vue?vue&type=script&setup=true&lang=js"

import "./reportXdjh.vue?vue&type=style&index=0&id=56ec5874&lang=less"

const __exports__ = script;

export default __exports__